import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import ExportButtons from '../Common/ExportButtons';

export interface ActivityPoint {
  label: string;
  value: number;
}

interface Props {
  data: ActivityPoint[];
  height?: number;
  ariaLabel?: string;
}

const ActivityLineChart: React.FC<Props> = ({ data, height = 260, ariaLabel = 'Legislative activity over time' }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const grid = theme.palette.divider;
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerRef} role="img" aria-label={ariaLabel} style={{ width: '100%', height }}>
      <ExportButtons filename="activity" data={data as any} containerRef={containerRef as any} />
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="activityGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={primary} stopOpacity={0.3} />
              <stop offset="100%" stopColor={primary} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke={grid} vertical={false} />
          <XAxis dataKey="label" stroke={theme.palette.text.secondary} tick={{ fontSize: 12 }} />
          <YAxis stroke={theme.palette.text.secondary} tick={{ fontSize: 12 }} allowDecimals={false} />
          <Tooltip
            contentStyle={{ background: theme.palette.background.paper, border: `1px solid ${grid}`, borderRadius: 8 }}
            labelStyle={{ color: theme.palette.text.secondary }}
            formatter={(v: any) => [v, 'Bills']}
          />
          <Area type="monotone" dataKey="value" stroke={primary} strokeWidth={2} fill="url(#activityGradient)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityLineChart;
